module.exports = __webpack_public_path__ + "img/patent_6.221ab91.jpg";